(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["green24-bloom-art"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('green24-keim-bloom')) {
  customElements.define('green24-keim-bloom', class extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.button = this.querySelector('button');
      this.react = () => {
        if (this.media.matches || this.dataset.visible !== 'true' || this.classList.contains('is-reacting')) return;
        this.classList.add('is-reacting');
        this.timer = setTimeout(() => { this.classList.remove('is-reacting'); this.timer = 0; }, 1100);
      };
      this.updateMotion = () => {
        this.dataset.visible = String(this.inView && !document.hidden && !this.media.matches);
        if (this.dataset.visible === 'false') {
          clearTimeout(this.timer);
          this.timer = 0;
          this.classList.remove('is-reacting');
        }
      };
      this.button.addEventListener('pointerenter', this.react);
      this.button.addEventListener('click', this.react);
      this.button.addEventListener('focus', this.react);
      document.addEventListener('visibilitychange', this.updateMotion);
      this.media.addEventListener('change', this.updateMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateMotion();
        }, {threshold: .08});
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.updateMotion();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.button?.removeEventListener('pointerenter', this.react);
      this.button?.removeEventListener('click', this.react);
      this.button?.removeEventListener('focus', this.react);
      document.removeEventListener('visibilitychange', this.updateMotion);
      this.media?.removeEventListener('change', this.updateMotion);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-care-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-care-guide')) customElements.define('g24-care-guide',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-care-site]')) this.querySelectorAll('[data-care-context]').forEach(node=>node.hidden=node.dataset.careContext!==event.target.value);
        if(event.target.matches('[data-care-need]')) this.openTopic(event.target.value);
      });
      this.addEventListener('click',event=>{
        const link=event.target.closest('[data-care-jump]');
        if(link) this.openTopic(link.dataset.careJump);
      });
    }
    openTopic(key) {
      if(!key) return;
      this.querySelectorAll('[data-care-topic]').forEach(node=>node.open=node.dataset.careTopic===key);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-cleaner-warning"] && !Shopify.designMode) return;
  try {
    (() => {
    const observers = new WeakMap();
    const initialize = (root = document) => {
      root.querySelectorAll('.g24-cleaner-warning[data-g24-cleaner-warning="image"]').forEach(tile => {
        if (observers.has(tile)) return;
        const gallery = tile.closest('slider-component');
        if (!gallery) return;
        const sync = () => {
          if (!tile.isConnected) return;
          gallery.style.setProperty('--g24-cleaner-warning-clearance', Math.ceil(tile.getBoundingClientRect().height + 24) + 'px');
        };
        const observer = new ResizeObserver(sync);
        observer.observe(tile);
        observers.set(tile, observer);
        sync();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('click', event => {
      const tile = event.target.closest?.('[data-g24-cleaner-warning-dismiss]');
      if (!tile) return;
      observers.get(tile)?.disconnect();
      tile.closest('slider-component')?.style.removeProperty('--g24-cleaner-warning-clearance');
    }, true);
  })();
  document.addEventListener('click', (event) => {
    const tile = event.target.closest?.('[data-g24-cleaner-warning-dismiss]');
    if (!tile) return;
    event.stopPropagation();
    const gallery = tile.closest('slider-component');
    const zoom = gallery?.querySelector('.product__media-item.is-active .product__media-toggle') || gallery?.querySelector('.product__media-toggle');
    if (zoom) zoom.focus({ preventScroll: true });
    else tile.blur();
    tile.remove();
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-competence-pilot"] && !Shopify.designMode) return;
  try {
    function g24TomatoNumber(value) {
    const text = String(value).trim();
    if (!/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(text)) return null;
    const n = Number(text.replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : null;
  }
  function g24TomatoMix(mode, water, height, width, unit, stage, dose, base, geometryLow, geometryHigh, stages, geometryEnabled) {
    if (!['water','plant'].includes(mode) || !stages.includes(stage) || !Number.isFinite(dose) || !Number.isFinite(base) || dose <= 0 || base <= 0) return null;
    let low, high;
    if (mode === 'water') {
      low = g24TomatoNumber(water);
      if (low === null || low < .1) return null;
      high = low;
    } else {
      if (!geometryEnabled || !['cm','m'].includes(unit) || !Number.isFinite(geometryLow) || !Number.isFinite(geometryHigh) || geometryLow <= 0 || geometryHigh < geometryLow) return null;
      const h = g24TomatoNumber(height), w = g24TomatoNumber(width);
      if (h === null || w === null) return null;
      const area = h * w / (unit === 'cm' ? 10000 : 1);
      low = area * geometryLow; high = area * geometryHigh;
    }
    if (!Number.isFinite(high) || high > 1000 || low <= 0) return null;
    const mlLow = low * dose / base * stage, mlHigh = high * dose / base * stage;
    if (!Number.isFinite(mlHigh) || mlLow <= 0) return null;
    return {low, high, mlLow, mlHigh};
  }
  if (!customElements.get('g24-competence-dose')) {
    customElements.define('g24-competence-dose', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.mode = this.querySelector('[data-mode-input]');
        this.water = this.querySelector('[data-water-input]');
        this.stage = this.querySelector('[data-stage-input]');
        this.applicationMethod = this.querySelector('[data-application-method]');
        this.unit = this.querySelector('[data-unit-input]');
        this.height = this.querySelector('[data-height-input]');
        this.width = this.querySelector('[data-width-input]');
        this.previousUnit = this.unit.value;
        this.querySelectorAll('input').forEach(input => input.addEventListener('input', () => this.update()));
        [this.mode,this.stage,this.applicationMethod].filter(Boolean).forEach(select => select.addEventListener('change', () => this.update()));
        this.unit.addEventListener('change', () => {
          if (this.previousUnit !== this.unit.value) {
            const scale = this.unit.value === 'cm' ? 100 : .01;
            [this.height,this.width].forEach(input => {
              const n = g24TomatoNumber(input.value);
              if (n !== null) input.value = String(Number((n * scale).toPrecision(12)));
            });
            this.previousUnit = this.unit.value;
          }
          this.update();
        });
        this.update();
      }
      update() {
        const plant = this.mode.value === 'plant';
        this.querySelector('[data-water-fields]').hidden = plant;
        this.querySelector('[data-plant-fields]').hidden = !plant;
        this.querySelector('[data-plant-note]').hidden = !plant;
        this.querySelector('[data-water-result-label]').hidden = plant;
        this.querySelector('[data-plant-result-label]').hidden = !plant;
        this.querySelectorAll('[data-size-unit]').forEach(n => n.textContent = this.unit.value);
        const selectedMethod = this.applicationMethod?.selectedOptions[0];
        const selectedDose = selectedMethod ? Number(selectedMethod.dataset.concentrate) : Number(this.dataset.concentrate);
        const selectedWater = selectedMethod ? Number(selectedMethod.dataset.water) : Number(this.dataset.water);
        const stageNote = this.querySelector('[data-stage-note]');
        if (stageNote) { stageNote.textContent = this.stage.selectedOptions[0]?.dataset.note || ''; stageNote.hidden = !stageNote.textContent; }
        const result = g24TomatoMix(this.mode.value,this.water.value,this.height.value,this.width.value,this.unit.value,Number(this.stage.value),selectedDose,selectedWater,Number(this.dataset.geometryLow),Number(this.dataset.geometryHigh),Array.from(this.stage.options,o=>Number(o.value)),this.dataset.geometryEnabled === 'true');
        this.water.setAttribute('aria-invalid',String(!plant && !result));
        [this.height,this.width].forEach(input => input.setAttribute('aria-invalid',String(plant && !result)));
        this.querySelector('[data-result-values]').hidden = !result;
        const error = this.querySelector('[data-calc-error]');
        error.textContent = plant ? this.dataset.invalidSizeLabel : this.dataset.invalidLabel;
        error.hidden = !!result;
        if (!result) return;
        const format = window.g24MoneyFormatter(this.dataset.locale || 'de',{maximumFractionDigits:3});
        const number = n => n < .001 ? '< ' + format.format(.001) : format.format(n);
        const range = (a,b) => a === b ? number(a) : number(a) + '–' + number(b);
        this.querySelector('[data-litres-output]').textContent = range(result.low,result.high) + ' l';
        this.querySelector('[data-dose-output]').textContent = range(result.mlLow,result.mlHigh) + ' ml';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-competence-uptake"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-fertilizer-uptake]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const tabs = Array.from(root.querySelectorAll('[data-uptake-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-uptake-panel]'));
        const chooseTab = (tab) => {
          tabs.forEach((t) => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
          panels.forEach((p) => { p.hidden = p.dataset.uptakePanel !== tab.dataset.uptakeTab; });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => chooseTab(tab));
          tab.addEventListener('keydown', (e) => {
            let next;
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') next = tabs[(index + 1) % tabs.length];
            if (e.key === 'Home') next = tabs[0];
            if (e.key === 'End') next = tabs[tabs.length - 1];
            if (next) { e.preventDefault(); chooseTab(next); next.focus(); }
          });
        });
        panels.forEach((panel) => {
          const buttons = Array.from(panel.querySelectorAll('[data-uptake-step]'));
          const chooseStep = (value) => {
            buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.uptakeStep === value)));
            panel.querySelectorAll('[data-uptake-detail]').forEach((d) => { d.hidden = d.dataset.uptakeDetail !== value; });
            panel.querySelector('.g24-explore__stage').dataset.selected = value;
          };
          panel.querySelectorAll('[data-uptake-next]').forEach((button) => {
            button.addEventListener('click', () => {
              const value = button.dataset.uptakeNext;
              chooseStep(value);
              panel.querySelector('[data-uptake-detail="' + value + '"] .g24-explore__next').focus({preventScroll:true});
            });
          });
          buttons.forEach((button) => {
            button.addEventListener('click', () => chooseStep(button.dataset.uptakeStep));
            button.addEventListener('focus', () => chooseStep(button.dataset.uptakeStep));
            button.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') chooseStep(button.dataset.uptakeStep); });
            button.addEventListener('keydown', (e) => {
              const peers = Array.from(button.parentElement.querySelectorAll('[data-uptake-step]'));
              const index = peers.indexOf(button);
              let next;
              if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = peers[(index + 1) % peers.length];
              if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = peers[(index + peers.length - 1) % peers.length];
              if (e.key === 'Home') next = peers[0];
              if (e.key === 'End') next = peers[peers.length - 1];
              if (next) { e.preventDefault(); next.focus(); }
            });
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-cutting-bundle-cart"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.g24CutBundleInitialized) return;
  window.g24CutBundleInitialized = true;
  let busy = false;
  let uncertain = false;
  const states = new WeakMap();
  const shearKinds = new Set(['hand_pruner', 'harvest', 'cut_hold', 'lopper', 'hedge', 'topiary', 'grass', 'pole_pruner']);
  const validId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const validPrice = value => value !== undefined && value !== null && value !== '' && Number.isSafeInteger(Number(value)) && Number(value) >= 0;
  const handles = value => Array.isArray(value) ? value.filter(item => typeof item === 'string') : typeof value === 'string' ? value.split(',').map(item => item.trim()).filter(Boolean) : [];
  const request = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal, credentials: 'same-origin' });
      const data = await response.json();
      return { response, data };
    } finally {
      clearTimeout(timer);
    }
  };
  const stateFor = root => {
    if (states.has(root)) return states.get(root);
    let config;
    try { config = JSON.parse(root.querySelector('[data-cut-bundle-config]').textContent); } catch { return null; }
    let cartUrl;
    let rootUrl;
    let money;
    try {
      cartUrl = new URL(config.cartUrl, window.location.origin);
      rootUrl = new URL(config.rootUrl, window.location.origin);
      money = window.g24MoneyFormatter(config.locale, { style: 'currency', currency: config.currency });
    } catch { return null; }
    if (cartUrl.origin !== window.location.origin || rootUrl.origin !== window.location.origin) return null;
    const state = { root, config, cartUrl, rootUrl, money, tool: null, opener: null, discountHandles: handles(config.discountHandles), holsterHandles: handles(config.holsterHandles) };
    states.set(root, state);
    return state;
  };
  const rootFor = button => {
    const host = button.closest('.g24-cut-host') || button.closest('.shopify-section');
    if (host) return host.querySelector('[data-cut-bundle-root]');
    const roots = document.querySelectorAll('[data-cut-bundle-root]');
    return roots.length === 1 ? roots[0] : null;
  };
  const addonAllowed = (input, state) => {
    if (!state.tool || !validId(input.dataset.cutVariantId) || !validPrice(input.dataset.cutPrice) || Number(input.dataset.cutPrice) <= 0 || Number(input.dataset.cutVariantId) === state.tool.id) return false;
    const role = input.dataset.cutAccessoryRole;
    if (role === 'apron') return true;
    if (role === 'sharpener') return shearKinds.has(state.tool.kind);
    return role === 'holster' && state.tool.vendor.toUpperCase() === 'FELCO' && ['hand_pruner', 'harvest'].includes(state.tool.kind) && state.holsterHandles.includes(state.tool.handle);
  };
  const selectedAddons = state => {
    const selected = new Map();
    state.root.querySelectorAll('[data-cut-addon]').forEach(input => {
      if (input.checked && !input.disabled && addonAllowed(input, state)) selected.set(Number(input.dataset.cutVariantId), { id: Number(input.dataset.cutVariantId), price: Number(input.dataset.cutPrice) });
    });
    return [...selected.values()];
  };
  const totals = state => {
    const addons = selectedAddons(state);
    const regular = state.tool.price + addons.reduce((sum, item) => sum + item.price, 0);
    const code = typeof state.config.discountCode === 'string' ? state.config.discountCode.trim() : '';
    const codeAllowed = /^[A-Za-z0-9][A-Za-z0-9_-]{0,254}$/.test(code) && (!state.discountHandles.length || state.discountHandles.includes(state.tool.handle));
    const discounted = codeAllowed && addons.length > 0;
    const saving = discounted ? [state.tool.price, ...addons.map(item => item.price)].reduce((sum, price) => sum + Math.floor(price * 5 / 100), 0) : 0;
    return { addons, regular, saving, total: regular - saving, code: discounted ? code : '', codeAllowed };
  };
  const refresh = state => {
    if (!state.tool) return;
    const amounts = totals(state);
    const format = value => state.money.format(value / 100);
    state.root.querySelector('[data-cut-bundle-regular]').textContent = format(amounts.regular);
    state.root.querySelector('[data-cut-bundle-saving]').textContent = '−' + format(amounts.saving);
    state.root.querySelector('[data-cut-bundle-total]').textContent = format(amounts.total);
    state.root.querySelector('[data-cut-bundle-saving-row]').hidden = !amounts.code;
    state.root.querySelector('[data-cut-bundle-total-label]').textContent = amounts.code ? state.config.bundleLabel : state.config.totalLabel;
    state.root.querySelector('[data-cut-bundle-offer]').hidden = !amounts.codeAllowed || amounts.addons.length > 0 || !state.root.querySelector('[data-cut-addon]:not(:disabled)');
    state.root.querySelector('[data-cut-bundle-discount-note]').hidden = !amounts.code;
  };
  const show = button => {
    const card = button.closest('[data-cut-card]');
    const root = rootFor(button);
    if (!card || !root || card.dataset.cutAvailable !== 'true') return;
    const state = stateFor(root);
    if (!state) return;
    const variantId = Number(button.dataset.cutVariantId);
    const pdfId = Number(state.config.pdfVariantId);
    if (!validId(variantId) || variantId === pdfId || !validPrice(card.dataset.cutPrice)) return;
    state.tool = { id: variantId, price: Number(card.dataset.cutPrice), handle: card.dataset.cutHandle || '', vendor: card.dataset.cutVendor || '', kind: card.dataset.cutKind || '' };
    state.opener = button;
    root.querySelector('[data-cut-bundle-tool-title]').textContent = card.dataset.cutTitle || card.querySelector('h4')?.textContent.trim() || '';
    root.querySelector('[data-cut-bundle-tool-price]').textContent = state.money.format(state.tool.price / 100);
    const sourceImage = card.querySelector('.g24-cut-card__image img');
    const image = root.querySelector('[data-cut-bundle-tool-image]');
    const imageUrl = sourceImage?.currentSrc || sourceImage?.src;
    image.hidden = !imageUrl;
    if (imageUrl) image.src = imageUrl;
    else image.removeAttribute('src');
    const seen = new Set();
    let visible = 0;
    root.querySelectorAll('[data-cut-addon]').forEach(input => {
      const allowed = addonAllowed(input, state) && !seen.has(input.dataset.cutVariantId);
      seen.add(input.dataset.cutVariantId);
      input.checked = false;
      input.disabled = !allowed;
      input.closest('[data-cut-addon-row]').hidden = !allowed;
      if (allowed) visible += 1;
    });
    root.querySelector('[data-cut-bundle-extras]').hidden = visible === 0 && !root.querySelector('[data-cut-bundle-pdf]');
    const pdf = root.querySelector('[data-cut-bundle-pdf]');
    if (pdf) {
      pdf.disabled = !validId(pdfId) || Number(pdf.dataset.cutVariantId) !== pdfId;
      pdf.checked = !pdf.disabled;
    }
    root.querySelector('[data-cut-bundle-status]').textContent = '';
    root.hidden = false;
    refresh(state);
    root.querySelector('[data-cut-bundle-heading]').focus({ preventScroll: true });
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  };
  const add = async state => {
    if (!state?.tool || busy || uncertain) return;
    const { root, config, cartUrl, tool } = state;
    const button = root.querySelector('[data-cut-bundle-submit]');
    const status = root.querySelector('[data-cut-bundle-status]');
    const amounts = totals(state);
    const pdf = root.querySelector('[data-cut-bundle-pdf]');
    const wantsPdf = Boolean(pdf?.checked && !pdf.disabled);
    const pdfId = Number(config.pdfVariantId);
    if (!validId(tool.id) || !validPrice(tool.price) || (wantsPdf && (!validId(pdfId) || tool.id === pdfId || Number(pdf.dataset.cutVariantId) !== pdfId))) {
      status.textContent = config.invalid;
      status.focus({ preventScroll: true });
      return;
    }
    const cartPath = cartUrl.pathname.replace(/\/$/, '');
    busy = true;
    const controls = Array.from(document.querySelectorAll('green24-cutting-configurator [data-cut-add-bundle], [data-cut-bundle-root] button, [data-cut-bundle-root] input')).map(item => ({ item, disabled: item.disabled }));
    controls.forEach(({ item }) => { item.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    status.textContent = config.loading;
    let submitted = false;
    let confirmed = false;
    try {
      const before = await request(cartPath + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!before.response.ok || !Array.isArray(before.data.items)) throw new Error('cart-read');
      const properties = { '_GREEN24 Bundle': 'Schnittkonfigurator' };
      const items = [{ id: tool.id, quantity: 1, properties }, ...amounts.addons.map(item => ({ id: item.id, quantity: 1, properties }))];
      const hasPdf = wantsPdf && before.data.items.some(item => Number(item.variant_id || item.id) === pdfId && Number(item.quantity) > 0);
      if (wantsPdf && !hasPdf) items.push({ id: pdfId, quantity: 1 });
      const drawer = document.querySelector('cart-drawer');
      const canRender = !amounts.code && drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
      const sections = canRender ? drawer.getSectionsToRender().slice(0, 5) : [];
      const body = { items };
      if (sections.length) {
        body.sections = sections.map(section => section.id);
        body.sections_url = window.location.pathname;
      }
      submitted = true;
      const added = await request(cartPath + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
      if (!added.response.ok || added.data.status || !Array.isArray(added.data.items) || !items.every(wanted => added.data.items.some(item => Number(item.variant_id || item.id) === wanted.id && Number(item.quantity) >= wanted.quantity))) throw new Error('cart-add');
      confirmed = true;
      status.textContent = config.success;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'g24-cutting-configurator', cartData: added.data, productVariantId: tool.id }); } catch {}
      }
      if (amounts.code) {
        const discountUrl = new URL('discount/' + encodeURIComponent(amounts.code), state.rootUrl.href.replace(/\/?$/, '/'));
        discountUrl.searchParams.set('redirect', cartUrl.pathname);
        window.location.assign(discountUrl.href);
        return;
      }
      const completeSections = sections.length > 0 && sections.every(section => {
        const html = added.data.sections?.[section.id];
        return typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      });
      if (canRender && completeSections) {
        try {
          drawer.setActiveElement?.(button);
          drawer.classList.remove('is-empty');
          drawer.renderContents(added.data);
          return;
        } catch {}
      }
      window.location.assign(cartUrl.href);
    } catch {
      uncertain = submitted && !confirmed;
      status.textContent = uncertain ? config.uncertain : confirmed ? config.success : config.readError;
      if (uncertain || confirmed) {
        const link = document.createElement('a');
        link.href = cartUrl.href;
        link.textContent = config.viewCart;
        status.append(document.createTextNode(' '), link);
      }
      status.focus({ preventScroll: true });
    } finally {
      busy = false;
      button.removeAttribute('aria-busy');
      if (!uncertain) controls.forEach(({ item, disabled }) => { item.disabled = disabled; });
    }
  };
  document.addEventListener('change', event => {
    const root = event.target.closest?.('[data-cut-bundle-root]');
    if (!root || busy || uncertain) return;
    const state = states.get(root);
    if (state) refresh(state);
  });
  document.addEventListener('click', event => {
    const choose = event.target.closest?.('green24-cutting-configurator [data-cut-add-bundle]');
    if (choose) {
      event.preventDefault();
      if (!choose.disabled && !busy && !uncertain) show(choose);
      return;
    }
    const button = event.target.closest?.('[data-cut-bundle-submit], [data-cut-bundle-close]');
    if (!button || button.disabled || busy || uncertain) return;
    event.preventDefault();
    const root = button.closest('[data-cut-bundle-root]');
    const state = states.get(root);
    if (!state) return;
    if (button.hasAttribute('data-cut-bundle-close')) {
      root.hidden = true;
      state.opener?.focus();
    } else add(state);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-cutting-configurator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('green24-cutting-configurator')){
  customElements.define('green24-cutting-configurator',class extends HTMLElement{
    connectedCallback(){
      if(this.controller&&!this.controller.signal.aborted)return;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.words=JSON.parse(this.querySelector('[data-cut-translations]').textContent);
      this.cards=Array.from(this.querySelectorAll('[data-cut-card]'));
      this.questions=Array.from(this.querySelectorAll('[data-cut-step]'));
      this.reset(false);
      this.querySelector('[data-cut-app]').hidden=false;
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-cut-step] input[type="radio"]'))this.updateNavigation();
        if(event.target.matches('[data-cut-refine]')){this.state[event.target.dataset.cutRefine]=event.target.value;if(event.target.dataset.cutRefine==='hand'){this.answered.add('hand');this.querySelectorAll('[data-cut-step="hand"] input').forEach(input=>{input.checked=input.value===this.state.hand;});}this.more={main:false,saws:false,check:false};this.renderResults(false);}
      },options);
      this.querySelector('[data-cut-diameter]').addEventListener('input',()=>{this.querySelector('[data-cut-step="diameter"] input[value="known"]').checked=true;this.querySelector('[data-cut-error]').hidden=true;},options);
      this.querySelector('[data-cut-next]').addEventListener('click',()=>{if(!this.commit())return;const current=this.step;this.steps=this.path();const at=this.steps.indexOf(current);if(at+1<this.steps.length)this.showStep(this.steps[at+1]);else this.renderResults();},options);
      this.querySelector('[data-cut-back]').addEventListener('click',()=>{const at=this.path().indexOf(this.step);this.showStep(this.path()[Math.max(0,at-1)]);},options);
      this.querySelector('[data-cut-show]').addEventListener('click',()=>{if(this.commit())this.renderResults();},options);
      this.querySelector('[data-cut-edit]').addEventListener('click',()=>this.showStep('purpose'),options);
      this.querySelector('[data-cut-restart]').addEventListener('click',()=>this.reset(true),options);
      for(const [key,selector] of [['main','[data-cut-more]'],['saws','[data-cut-more-saws]'],['check','[data-cut-more-check]']])this.querySelector(selector).addEventListener('click',()=>{this.more[key]=!this.more[key];this.renderResults(false);},options);
      this.querySelector('[data-cut-chips]').addEventListener('click',event=>{const button=event.target.closest('[data-cut-edit-step]');if(button)this.showStep(button.dataset.cutEditStep);},options);
    }
    disconnectedCallback(){this.controller?.abort();}
    reset(focus=true){
      this.state={purpose:'any',knifeTask:'any',reach:'any',diameter:null,wood:'any',shootTask:'any',holdReach:'any',hedgeTask:'any',hedgeReach:'any',hand:'any',size:'any'};this.answered=new Set();this.more={main:false,saws:false,check:false};
      this.querySelectorAll('input[type="radio"]').forEach(input=>{input.checked=input.value==='any';});this.querySelector('[data-cut-diameter]').value='';this.querySelector('[data-cut-error]').hidden=true;this.querySelectorAll('[data-cut-refine]').forEach(select=>{select.value='any';});this.showStep('purpose',focus);
    }
    branchTask(){return this.state.purpose==='branches'||this.state.purpose==='shoots'&&this.state.shootTask==='woody'||this.state.purpose==='hedges'&&this.state.hedgeTask==='thick';}
    path(){const s=this.state;let steps=['purpose'];if(s.purpose==='branches')steps.push('reach','diameter','wood');else if(s.purpose==='shoots'){steps.push('shootTask');if(s.shootTask==='woody')steps.push('reach','diameter','wood');else if(s.shootTask==='hold'&&this.cards?.some(card=>{const m=this.model(card,0);return m.tasks.includes('hold')&&m.reach.includes('overhead');}))steps.push('holdReach');}else if(s.purpose==='hedges'){steps.push('hedgeTask');if(s.hedgeTask==='thick')steps.push('reach','diameter','wood');else if(s.hedgeTask!=='any')steps.push('hedgeReach');}else if(s.purpose==='knives')steps.push('knifeTask');if(s.purpose!=='any'&&this.hasHandChoice())steps.push('hand');return steps;}
    hasHandChoice(){return this.cards?.some((card,index)=>{const m=this.rank(this.model(card,index),true);return m?.single&&['left','right','both'].includes(m.hand);});}
    clear(keys){for(const key of keys){this.state[key]=key==='diameter'?null:'any';this.answered.delete(key);const field=this.questions.find(q=>q.dataset.cutStep===key);if(field)field.querySelectorAll('input[type="radio"]').forEach(input=>{input.checked=input.value==='any';});}if(keys.includes('diameter'))this.querySelector('[data-cut-diameter]').value='';for(const key of ['hand','size'])if(keys.includes(key))this.querySelector('[data-cut-refine="'+key+'"]').value='any';}
    commit(){
      const field=this.questions.find(q=>q.dataset.cutStep===this.step);if(!field)return true;
      const selected=field.querySelector('input[type="radio"]:checked')?.value||'any';const old=this.state[this.step];let value=selected;
      if(this.step==='diameter'){const input=this.querySelector('[data-cut-diameter]');value=selected==='known'?Number(input.value):null;if(selected==='known'&&(!input.value||!Number.isInteger(value)||value<1||value>300)){this.querySelector('[data-cut-error]').hidden=false;input.setAttribute('aria-invalid','true');input.focus();return false;}input.removeAttribute('aria-invalid');this.querySelector('[data-cut-error]').hidden=true;}
      if(value!==old){if(this.step==='purpose')this.clear(['reach','diameter','wood','shootTask','holdReach','hedgeTask','hedgeReach','knifeTask','hand','size']);if(this.step==='shootTask')this.clear(['reach','diameter','wood','holdReach']);if(this.step==='hedgeTask')this.clear(['reach','diameter','wood','hedgeReach']);}
      this.state[this.step]=value;if(this.step==='hand')this.querySelector('[data-cut-refine="hand"]').value=value;this.answered.add(this.step);this.more={main:false,saws:false,check:false};this.renderChips();return true;
    }
    showStep(key,focus=true){
      this.step=key;this.querySelector('[data-cut-flow]').hidden=false;this.querySelector('[data-cut-results]').hidden=true;
      this.questions.forEach(field=>{field.hidden=field.dataset.cutStep!==key;});const steps=this.path();this.querySelector('[data-cut-progress]').textContent=this.words.step+' '+(Math.max(0,steps.indexOf(key))+1);this.querySelector('[data-cut-back]').hidden=key==='purpose';this.querySelector('[data-cut-next]').textContent=key==='purpose'&&this.state.purpose==='any'?this.words.next:steps.indexOf(key)===steps.length-1?this.words.show_results:this.words.next;this.renderChips();
      this.updateNavigation();
      if(focus)this.questions.find(q=>q.dataset.cutStep===key)?.querySelector('legend').focus({preventScroll:true});
    }
    updateNavigation(){
      const field=this.questions.find(q=>q.dataset.cutStep===this.step);const previous=this.state[this.step];
      if(field&&this.step!=='diameter')this.state[this.step]=field.querySelector('input[type="radio"]:checked')?.value||'any';
      const steps=this.path();this.state[this.step]=previous;const last=steps.indexOf(this.step)===steps.length-1;
      this.querySelector('[data-cut-next]').textContent=last?this.words.show_results:this.words.next;this.querySelector('[data-cut-show]').hidden=last;
    }
    renderChips(){
      const container=this.querySelector('[data-cut-chips]');container.replaceChildren();
      for(const key of this.path()){if(!this.answered.has(key))continue;const value=this.state[key];const label=key==='diameter'?(value===null?this.words.diameter_unknown:value+' mm'):this.words[value]||this.words.either;const button=document.createElement('button');button.type='button';button.className='g24-cut__chip';button.dataset.cutEditStep=key;button.textContent=this.words['chip_'+key]+': '+label;button.setAttribute('aria-label',this.words.edit+': '+button.textContent);container.append(button);}
      this.querySelector('[data-cut-summary]').hidden=container.children.length===0;
    }
    model(card,index){
      const d=card.dataset;const tokens=value=>(value||'').split(/\s+/).filter(Boolean);const capacity=Number(d.cutCapacity);
      return {card,index,vendor:(d.cutVendor||'').trim().toLowerCase(),kind:d.cutKind||'',tasks:tokens(d.cutTasks),reach:tokens(d.cutReach),capacity:Number.isFinite(capacity)&&capacity>0?capacity:null,confirmed:d.cutCapacityConfirmed==='true',principle:d.cutPrinciple||'unknown',hand:d.cutHand||'unknown',sizes:tokens(d.cutSizes),available:d.cutAvailable==='true',system:d.cutSystemValid==='true'};
    }
    rank(model,ignoreFit=false){
      const s=this.state;const branch=this.branchTask();const allowed=['hand_pruner','lopper','saw','harvest','cut_hold','hedge','topiary','grass','pole_pruner','pole_saw','knife'];if(!allowed.includes(model.kind))return null;
      const single=['hand_pruner','harvest','cut_hold','grass'].includes(model.kind)&&model.reach.includes('hand');const shears=['hand_pruner','lopper','pole_pruner','cut_hold'].includes(model.kind);const saw=['saw','pole_saw'].includes(model.kind);let task='any',reach='any';
      if(branch){task='branches';reach=s.reach;}else if(s.purpose==='shoots'){task=s.shootTask==='any'?'shoots':s.shootTask;reach=s.shootTask==='hold'?s.holdReach:'any';}else if(s.purpose==='knives'){task=s.knifeTask==='any'?'knives':s.knifeTask;}else if(s.purpose==='hedges'){task=s.hedgeTask==='form'?'topiary':s.hedgeTask==='surface'?'hedge':'hedges';reach=s.hedgeTask==='any'?'any':s.hedgeReach==='extended'?'overhead':s.hedgeReach;}
      if(task==='shoots'&&!model.tasks.some(t=>['harvest','hold','branches','grass'].includes(t)))return null;
      if(task==='hedges'&&!model.tasks.some(t=>['hedge','topiary','branches'].includes(t)))return null;
      if(!['any','shoots','hedges'].includes(task)&&!model.tasks.includes(task))return null;
      if(reach!=='any'&&!model.reach.includes(reach))return null;
      if(['pole_pruner','pole_saw'].includes(model.kind)&&!model.system)return null;
      if(reach==='pole'&&!['pole_pruner','pole_saw'].includes(model.kind))return null;
      if(branch&&s.diameter!==null&&model.confirmed&&model.capacity!==null&&model.capacity<s.diameter)return null;
      if(branch&&s.wood==='live'&&model.principle==='anvil')return null;
      if(branch&&['mixed','any'].includes(s.wood)&&model.principle==='anvil')return null;
      if(single&&!ignoreFit){if(s.hand!=='any'&&model.hand!==s.hand&&model.hand!=='both')return null;if(s.size!=='any'&&!model.sizes.includes(s.size))return null;}
      let score=model.available?100:0;const reasons=[];let group='main';
      if(branch&&shears&&s.diameter!==null&&(!model.confirmed||model.capacity===null)){group='check';reasons.push(this.words.reason_unknown);}
      else if(branch&&shears){if(model.confirmed&&model.capacity!==null){score+=20;reasons.push(this.words.reason_capacity.replace('__G24_VALUE__',model.capacity));}else reasons.push(this.words.reason_unknown);}
      if(branch&&saw){group='saws';reasons.push(this.words.reason_saw);score+=10;}
      if(branch&&s.wood==='dry'&&model.principle==='anvil'){score+=15;reasons.push(this.words.reason_anvil);}else if(branch&&model.principle==='bypass'){score+=s.wood==='dry'?0:15;reasons.push(this.words.reason_bypass);}
      if(['budding','grafting','floral','pruning_knife','knives'].includes(task))reasons.push(this.words['reason_'+task]);if(task==='hold'){score+=20;reasons.push(this.words.reason_hold);}if(task==='harvest')reasons.push(this.words.reason_harvest);if(task==='hedge')reasons.push(this.words.reason_hedge);if(task==='topiary')reasons.push(this.words.reason_form);if(task==='grass')reasons.push(this.words.reason_grass);
      if(single&&s.hand!=='any'){score+=5;reasons.push(this.words.reason_hand);}if(single&&s.size!=='any'){score+=3;reasons.push(this.words.reason_size);}if(model.system&&['pole_pruner','pole_saw'].includes(model.kind))reasons.unshift(this.words.reason_system);
      if(reasons.length===0)reasons.push(this.words.reason_task);
      return {...model,score,group,reasons:reasons.slice(0,2),single};
    }
    orderMatches(items){
      const result=[];const sorted=[...items].sort((a,b)=>b.score-a.score||a.index-b.index);
      while(sorted.length){const score=sorted[0].score;const tied=[];while(sorted.length&&sorted[0].score===score)tied.push(sorted.shift());const vendors=new Set();const kinds=new Set();while(tied.length){let at=tied.findIndex(m=>!vendors.has(m.vendor)&&(this.state.purpose!=='any'||!kinds.has(m.kind)));if(at<0)at=tied.findIndex(m=>!vendors.has(m.vendor));if(at<0&&this.state.purpose==='any')at=tied.findIndex(m=>!kinds.has(m.kind));if(at<0)at=0;const [next]=tied.splice(at,1);result.push(next);vendors.add(next.vendor);kinds.add(next.kind);}}
      return result;
    }
    renderResults(focus=true){
      this.querySelector('[data-cut-flow]').hidden=true;this.querySelector('[data-cut-results]').hidden=false;this.renderChips();
      const models=this.cards.map((card,index)=>this.model(card,index));const possible=models.map(m=>this.rank(m,true)).filter(Boolean);const matches=models.map(m=>this.rank(m)).filter(Boolean).sort((a,b)=>b.score-a.score||a.index-b.index);
      this.cards.forEach(card=>{card.hidden=true;card.classList.remove('is-best-match');});
      const groups={main:[],saws:[],check:[]};matches.forEach(m=>groups[m.group].push(m));
      for(const key of Object.keys(groups))groups[key]=this.orderMatches(groups[key]);
      if(this.state.purpose!=='any'&&!this.openCore()&&groups.main[0]?.available&&(!groups.main[1]||groups.main[0].score>groups.main[1].score))groups.main[0].card.classList.add('is-best-match');
      for(const [key,selector,moreSelector] of [['main','[data-cut-results-list]','[data-cut-more]'],['saws','[data-cut-saw-list]','[data-cut-more-saws]'],['check','[data-cut-check-list]','[data-cut-more-check]']]){
        const list=this.querySelector(selector);groups[key].forEach((item,index)=>{list.append(item.card);item.card.hidden=!this.more[key]&&index>=3;let reason=item.card.querySelector('[data-cut-reasons]');if(!reason){reason=document.createElement('p');reason.dataset.cutReasons='';item.card.append(reason);}reason.textContent=item.reasons.join(' · ');item.card.dataset.cutCertainty=key==='check'?'check-capacity':this.openCore()?'orientation':'task-match';});const more=this.querySelector(moreSelector);more.hidden=groups[key].length<=3;more.textContent=this.more[key]?this.words.less:this.words.more;more.setAttribute('aria-expanded',String(this.more[key]));
      }
      const singles=possible.filter(m=>m.single);const showHand=singles.some(m=>['left','right','both'].includes(m.hand))||this.state.hand!=='any';const showSize=singles.some(m=>m.sizes.length>0)||this.state.size!=='any';this.querySelector('[data-cut-refine="hand"]').closest('label').hidden=!showHand;this.querySelector('[data-cut-refine="size"]').closest('label').hidden=!showSize;
      this.querySelector('[data-cut-saws]').hidden=groups.saws.length===0;this.querySelector('[data-cut-check]').hidden=groups.check.length===0;this.querySelector('[data-cut-empty]').hidden=groups.main.length>0;this.querySelector('[data-cut-refinement]').hidden=singles.length===0||!showHand&&!showSize;this.querySelector('[data-cut-orientation]').hidden=!this.openCore();this.querySelector('[data-cut-system]').hidden=!matches.some(m=>['pole_pruner','pole_saw'].includes(m.kind));this.querySelector('[data-cut-count]').textContent=this.words.count.replace('__G24_VALUE__',matches.length);
      if(focus)this.querySelector('[data-cut-results] h3').focus({preventScroll:true});
    }
    openCore(){const s=this.state;if(s.purpose==='any')return true;if(s.purpose==='knives')return s.knifeTask==='any';if(this.branchTask())return s.reach==='any'||s.diameter===null||s.wood==='any';if(s.purpose==='shoots')return s.shootTask==='any'||s.shootTask==='hold'&&this.path().includes('holdReach')&&s.holdReach==='any';return s.hedgeTask==='any'||s.hedgeReach==='any';}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-dose-calculator"] && !Shopify.designMode) return;
  try {
    // Decimal string shifting keeps unit toggles exact and leaves invalid edits untouched.
  function green24DoseShift(value, places) {
    const original = String(value);
    const text = original.trim();
    if (!/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(text)) return original;
    const [whole = '', fraction = ''] = text.replace(',', '.').split('.');
    let digits = whole + fraction;
    let point = whole.length + places;
    if (point < 0) { digits = '0'.repeat(-point) + digits; point = 0; }
    if (point > digits.length) digits += '0'.repeat(point - digits.length);
    const integer = (digits.slice(0, point) || '0').replace(/^0+(?=\d)/, '');
    const decimal = digits.slice(point).replace(/0+$/, '');
    return integer + (decimal ? (text.includes(',') ? ',' : '.') + decimal : '');
  }
  function green24DoseState(unit = 'm') {
    const size = unit === 'cm' ? '100' : '1';
    return {mode:'water', unit, values:{water:{a:'10',b:'1'},plant:{a:size,b:size},tree:{a:size,b:size},hedge:{a:size,b:size}}};
  }
  function green24DoseChangeMode(state, mode, a, b) {
    if (state.values[state.mode]) state.values[state.mode] = {a,b};
    state.mode = mode;
    return state.values[mode] || {a,b};
  }
  function green24DoseChangeUnit(state, unit, a, b) {
    if (!['m','cm'].includes(unit)) return {a,b};
    if (state.values[state.mode]) state.values[state.mode] = {a,b};
    if (unit !== state.unit) {
      const places = unit === 'cm' ? 2 : -2;
      for (const mode of ['plant','tree','hedge']) {
        const values = state.values[mode];
        values.a = green24DoseShift(values.a, places);
        values.b = green24DoseShift(values.b, places);
      }
      state.unit = unit;
    }
    return state.values[state.mode] || {a,b};
  }
  function green24DoseNumber(value) {
    const text = String(value).trim();
    if (!/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(text)) return null;
    const result = Number(text.replace(',', '.'));
    return Number.isFinite(result) && result > 0 && result <= 1000000 ? result : null;
  }
  function green24DoseApplicationRate(mode, baseDose, methodDose) {
    return mode === 'water' && Number.isFinite(methodDose) && methodDose > 0 ? methodDose : baseDose;
  }
  // A declared programme never falls back to a different product/base dose.
  function green24DoseProgram(option) {
    if (!option || !option.value) return null;
    const concentrate = green24DoseNumber(option.dataset.concentrate);
    const water = green24DoseNumber(option.dataset.water);
    if (!concentrate || !water || !option.dataset.description) return null;
    return {concentrate, water, dose:concentrate/water, description:option.dataset.description, growth:option.dataset.growth === 'true'};
  }
  function green24DoseFactor(plus) { return plus === true ? 4 : 3; }
  function green24DoseCalculate(mode, a, b, dose, factor = 3, stage = 1, unit = 'm') {
    if (!['water','plant','tree','hedge'].includes(mode) || ![1,0.5,0.25,0.2].includes(stage)) return null;
    if (mode !== 'water' && !['m','cm'].includes(unit)) return null;
    const first = green24DoseNumber(mode !== 'water' && unit === 'cm' ? green24DoseShift(a, -2) : a);
    const second = mode === 'water' ? 1 : green24DoseNumber(unit === 'cm' ? green24DoseShift(b, -2) : b);
    if (first === null || second === null || !Number.isFinite(dose) || dose <= 0) return null;
    if (mode !== 'water' && ![3,4].includes(factor)) return null;
    const base = first * second;
    const low = mode === 'water' ? base : base * factor;
    const high = low;
    if (!Number.isFinite(high * dose) || high > 1000000) return null;
    return { low, high, mlLow:low*dose*stage, mlHigh:high*dose*stage };
  }
  if (!customElements.get('g24-dose-calculator')) {
    customElements.define('g24-dose-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.mode = this.querySelector('[data-dose-mode]');
        this.stage = this.querySelector('[data-dose-stage]');
        this.program = this.querySelector('[data-dose-program]');
        if (this.program) {
          this.program.addEventListener('change', () => this.update());
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.update(), {once:true});
        }
        this.stage.addEventListener('change', () => this.update());
        this.factor = this.querySelector('[data-dose-factor]');
        this.factor.addEventListener('change', () => this.update());
        this.application = this.querySelector('[data-dose-application]');
        if (this.application) this.application.addEventListener('change', () => this.update());
        this.rate = this.querySelector('[data-dose-rate]');
        if (this.rate) this.rate.addEventListener('change', () => this.update());
        this.a = this.querySelector('[data-dose-a]');
        this.b = this.querySelector('[data-dose-b]');
        this.unit = this.querySelector('[data-dose-unit]');
        this.inputState = green24DoseState(this.unit.value);
        this.inputState.mode = this.mode.value;
        this.mode.addEventListener('change', () => {
          const values = green24DoseChangeMode(this.inputState, this.mode.value, this.a.value, this.b.value);
          this.a.value = values.a; this.b.value = values.b;
          this.update();
        });
        this.unit.addEventListener('change', () => {
          const values = green24DoseChangeUnit(this.inputState, this.unit.value, this.a.value, this.b.value);
          this.a.value = values.a; this.b.value = values.b;
          this.update();
        });
        this.a.addEventListener('input', () => this.update());
        this.b.addEventListener('input', () => this.update());
        this.update();
      }
      show(selector, visible) { this.querySelectorAll(selector).forEach(node => node.hidden = !visible); }
      update() {
        const mode = this.program || this.dataset.waterOnly === 'true' ? 'water' : this.mode.value;
        this.querySelectorAll('[data-dose-mode-help]').forEach(node => node.hidden = node.dataset.doseModeHelp !== mode);
        const special = mode === 'hydro' || mode === 'system';
        const geometry = !special && mode !== 'water';
        const unit = this.unit.value;
        this.show('[data-dose-unit-control]', geometry);
        this.querySelectorAll('[data-dose-unit-label]').forEach(node => node.textContent = unit);
        const stage = this.application ? 1 : this.dataset.waterOnly === 'true' ? (this.dataset.qualifiedYoung === 'true' ? (['1', '0.5'].includes(this.stage.value) ? Number(this.stage.value) : NaN) : 1) : Number(this.stage.value);
        const stageNote = this.querySelector('[data-dose-stage-note]');
        const optionsState = this.querySelector('[data-dose-options-state]');
        if (optionsState) optionsState.textContent = this.mode.selectedOptions[0].textContent + ' · ' + this.stage.selectedOptions[0].textContent;
        const stageNoteText = this.stage.selectedOptions[0]?.dataset.note || '';
        if (stageNote) {
          stageNote.textContent = stageNoteText;
          stageNote.hidden = special || !stageNoteText;
        }
        this.show('[data-dose-stage-control],[data-dose-rate-control]', !special);
        this.show('[data-dose-application-control]', mode === 'water');
        if (this.application) this.show('[data-dose-stage-control]', false);
        this.show('[data-dose-factor-normal]', !this.factor.checked);
        this.show('[data-dose-factor-plus]', this.factor.checked);
        this.show('[data-dose-inputs],[data-dose-label-rate]', !special);
        this.show('[data-dose-second],[data-dose-geometry],[data-dose-formula],[data-dose-purpose],[data-dose-purpose-note]', geometry);
        this.show('[data-dose-water-label],[data-dose-water-title]', mode === 'water');
        this.show('[data-dose-solution-title],[data-dose-solution-concentrate]', geometry);
        this.show('[data-dose-plus],[data-dose-water-concentrate]', mode === 'water');
        this.show('[data-dose-plant-label],[data-dose-height-label],[data-dose-plant-formula]', mode === 'plant');
        this.show('[data-dose-tree-label],[data-dose-tree-height],[data-dose-tree-formula]', mode === 'tree');
        this.show('[data-dose-hedge-label],[data-dose-hedge-height],[data-dose-hedge-formula],[data-dose-hedge-note]', mode === 'hedge');
        this.show('[data-dose-hydro]', mode === 'hydro');
        this.show('[data-dose-system]', mode === 'system');
        const baseDose = this.rate ? Number(this.rate.value) : Number(this.dataset.dose);
        const program = this.program ? green24DoseProgram(this.program.selectedOptions[0]) : null;
        const dose = this.program ? (program ? program.dose : NaN) : green24DoseApplicationRate(mode, baseDose, this.application ? Number(this.application.value) : null);
        if (this.program) {
          const de = (this.dataset.locale || 'de').startsWith('de');
          const format = window.g24MoneyFormatter(this.dataset.locale || 'de', {maximumFractionDigits:3});
          const number = n => format.format(n);
          const empty = de ? 'Bitte gültiges Anwendungsprogramm wählen.' : 'Choose a valid application programme.';
          const rate = program ? (de ? number(program.concentrate * stage) + ' ml auf ' + number(program.water) + ' Liter Wasser' : number(program.concentrate * stage) + ' ml per ' + number(program.water) + ' litres of water') : empty;
          const growth = program && program.growth ? (de ? ' Nur bei aktivem Wachstum; bei Ruhe pausieren.' : ' Only during active growth; pause during dormancy.') : '';
          const reach = program ? (de ? ' 250 ml reichen bei der gewählten Dosierung für ' : ' At the selected dose, 250 ml makes ') + number(250 / (program.dose * stage)) + ' L.' : '';
          const note = program ? program.description + growth + reach : empty;
          this.querySelector('[data-dose-program-note]').textContent = note;
          this.querySelector('[data-dose-label-rate]').textContent = rate;
          this.program.setAttribute('aria-invalid', String(!program));
          document.querySelectorAll('[data-dose-program-copy]').forEach(node => {
            if (node.dataset.doseProgramCopy === this.dataset.productId) node.textContent = rate + (program ? ' · ' + program.description + growth : '');
          });
        }
        const result = green24DoseCalculate(mode, this.a.value, this.b.value, dose, green24DoseFactor(this.factor.checked), stage, unit);
        this.show('[data-dose-result],[data-dose-mix]', !!result && !special);
        this.show('[data-dose-error]', !result && !special);
        this.a.setAttribute('aria-invalid', String(!special && green24DoseNumber(geometry && unit === 'cm' ? green24DoseShift(this.a.value, -2) : this.a.value) === null));
        this.b.setAttribute('aria-invalid', String(geometry && green24DoseNumber(unit === 'cm' ? green24DoseShift(this.b.value, -2) : this.b.value) === null));
        if (!result) return;
        const format = window.g24MoneyFormatter(this.dataset.locale || 'de', {maximumFractionDigits:3});
        const number = value => value > 0 && value < 0.001 ? '< ' + format.format(0.001) : format.format(value);
        const range = (low, high) => low === high ? number(low) : number(low) + '–' + number(high);
        this.querySelector('[data-dose-litres]').textContent = range(result.low,result.high) + ' L';
        this.querySelector('[data-dose-ml]').textContent = range(result.mlLow,result.mlHigh) + ' ml';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-dose-range"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-dose-range')) {
    customElements.define('g24-dose-range', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('[data-range-water]');
        const update = () => {
          const raw = input.value.trim();
          const water = /^(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(raw) ? Number(raw.replace(',', '.')) : NaN;
          const concentrate = Number(this.dataset.concentrate);
          const minWater = Number(this.dataset.waterMin);
          const maxWater = Number(this.dataset.waterMax);
          const low = water * concentrate / maxWater;
          const high = water * concentrate / minWater;
          const valid = concentrate > 0 && minWater > 0 && maxWater >= minWater && Number.isFinite(water) && water > 0 && Number.isFinite(low) && Number.isFinite(high) && low > 0 && high >= low;
          input.setAttribute('aria-invalid', String(!valid));
          this.querySelector('[data-range-error]').hidden = valid;
          this.querySelector('[data-range-result]').hidden = !valid;
          if (!valid) return;
          const format = window.g24MoneyFormatter(this.dataset.locale || 'de', { maximumFractionDigits: 3 });
          const number = value => value < 0.001 ? '< ' + format.format(0.001) : format.format(value);
          this.querySelector('[data-range-output]').textContent = high < 0.001 ? '< ' + format.format(0.001) + ' ml' : (low === high ? number(low) + ' ml' : '≈ ' + number(low) + '–' + number(high) + ' ml');
        };
        input.addEventListener('input', update);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-fertilizer-uptake"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-fertilizer-uptake]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const tabs = Array.from(root.querySelectorAll('[data-uptake-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-uptake-panel]'));
        const chooseTab = (tab) => {
          tabs.forEach((t) => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
          panels.forEach((p) => { p.hidden = p.dataset.uptakePanel !== tab.dataset.uptakeTab; });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => chooseTab(tab));
          tab.addEventListener('keydown', (e) => {
            let next;
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') next = tabs[(index + 1) % tabs.length];
            if (e.key === 'Home') next = tabs[0];
            if (e.key === 'End') next = tabs[tabs.length - 1];
            if (next) { e.preventDefault(); chooseTab(next); next.focus(); }
          });
        });
        panels.forEach((panel) => {
          const buttons = Array.from(panel.querySelectorAll('[data-uptake-step]'));
          const chooseStep = (value) => {
            buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.uptakeStep === value)));
            panel.querySelectorAll('[data-uptake-detail]').forEach((d) => { d.hidden = d.dataset.uptakeDetail !== value; });
            panel.querySelector('.g24-explore__stage').dataset.selected = value;
          };
          panel.querySelectorAll('[data-uptake-next]').forEach((button) => {
            button.addEventListener('click', () => {
              const value = button.dataset.uptakeNext;
              chooseStep(value);
              panel.querySelector('[data-uptake-detail="' + value + '"] .g24-explore__next').focus({preventScroll:true});
            });
          });
          buttons.forEach((button) => {
            button.addEventListener('click', () => chooseStep(button.dataset.uptakeStep));
            button.addEventListener('focus', () => chooseStep(button.dataset.uptakeStep));
            button.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') chooseStep(button.dataset.uptakeStep); });
            button.addEventListener('keydown', (e) => {
              const peers = Array.from(button.parentElement.querySelectorAll('[data-uptake-step]'));
              const index = peers.indexOf(button);
              let next;
              if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = peers[(index + 1) % peers.length];
              if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = peers[(index + peers.length - 1) % peers.length];
              if (e.key === 'Home') next = peers[0];
              if (e.key === 'End') next = peers[peers.length - 1];
              if (next) { e.preventDefault(); next.focus(); }
            });
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-fertilizer-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-guide-video')) customElements.define('g24-guide-video',class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      const player=this.querySelector('video');
      const launch=this.querySelector('[data-video-launch]');
      const disclosure=this.querySelector('.g24-fertilizer-video__disclosure');
      if(!player||!launch||!disclosure) return;
      launch.addEventListener('click',()=>{
        launch.hidden=true;
        player.hidden=false;
        player.focus();
        player.play().catch(()=>{});
      });
      disclosure.addEventListener('toggle',()=>{if(!disclosure.open) player.pause();});
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-hydro-application-core"] && !Shopify.designMode) return;
  try {
    function g24HydroMixture(input) {
  if (typeof input !== 'string' && typeof input !== 'number') return null;
  const s = String(input).trim();
  if (!/^(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(s)) return null;
  const waterLitres = Number(s.replace(',', '.'));
  if (!Number.isFinite(waterLitres) || waterLitres < 0.1 || waterLitres > 1000) return null;
  return { waterLitres, concentrateMl: waterLitres * 5 / 1.5, scope: 'preparation_only' };
}
if (!customElements.get('g24-hydro-mixture')) {
  customElements.define('g24-hydro-mixture', class extends HTMLElement {
    connectedCallback() {
      if (this._hydroAbort) this._hydroAbort.abort();
      this._hydroAbort = new AbortController();
      const input = this.querySelector('[data-hydro-water]');
      if (!input) return;
      input.addEventListener('input', () => this.update(), {signal:this._hydroAbort.signal});
      this.update();
    }
    disconnectedCallback() { if(this._hydroAbort) this._hydroAbort.abort(); }
    update() {
      const input = this.querySelector('[data-hydro-water]'), result = this.querySelector('[data-hydro-result]'), error = this.querySelector('[data-hydro-error]');
      if (!input || !result || !error) return;
      const r = g24HydroMixture(input.value);
      input.setAttribute('aria-invalid', r ? 'false' : 'true');
      error.hidden = Boolean(r);
      error.textContent = r ? '' : this.dataset.invalid;
      result.textContent = r ? new Intl.NumberFormat(this.dataset.locale === 'de' ? 'de-DE' : 'en-GB', {maximumFractionDigits:3}).format(r.concentrateMl)+' ml' : '—';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-knowledge-curated"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('g24-knowledge-picker')) customElements.define('g24-knowledge-picker',class extends HTMLElement {
    connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('change',e=>{if(!e.target.matches('select')||!e.target.value)return;const section=this.closest('section');const details=[...section.querySelectorAll('[data-g24-care-key]')].find(n=>n.dataset.g24CareKey===e.target.value);if(details){details.open=true;details.querySelector('summary').focus({preventScroll:true});details.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}});}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-library-film"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('g24-library-film'))customElements.define('g24-library-film',class extends HTMLElement {
    connectedCallback(){if(this.ready)return;this.ready=true;const d=this.querySelector('details'),v=this.querySelector('video');if(d&&v)d.addEventListener('toggle',()=>{if(!d.open)v.pause();});}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-minigarden-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-mini-slider')) {
    customElements.define('g24-mini-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (this.slides.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.requestId = 0;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.finish();
        this.dots.forEach((dot, i) => { if (i === 0) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.querySelector('[data-controls]').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
        this.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.go(targets[event.key]);
        }, options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.finish(); }, options);
      }
      finish() {
        clearTimeout(this.fadeTimer);
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.hidden = !active;
          slide.inert = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
      }
      async go(target) {
        const index = (target + this.slides.length) % this.slides.length;
        if (index === this.index) { ++this.requestId; return; }
        const requestId = ++this.requestId;
        const next = this.slides[index];
        const image = next.querySelector('img');
        if (image) {
          image.loading = 'eager';
          try { await image.decode(); } catch { return; }
        }
        if (!this.isConnected || requestId !== this.requestId) return;
        this.finish();
        const previous = this.slides[this.index];
        next.hidden = false;
        next.inert = false;
        next.setAttribute('aria-hidden', 'false');
        previous.inert = true;
        previous.setAttribute('aria-hidden', 'true');
        this.index = index;
        this.dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (this.motion.matches) this.finish();
        else {
          next.getBoundingClientRect();
          next.classList.add('is-active');
          previous.classList.remove('is-active');
          this.fadeTimer = setTimeout(() => this.finish(), 820);
        }
        this.querySelector('[data-status]').textContent = next.getAttribute('aria-label');
      }
      disconnectedCallback() {
        this.requestId++;
        clearTimeout(this.fadeTimer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-mvd-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const openPresentationAnchor = (hash) => {
    if (!hash || hash.charAt(0) !== '#') return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
    if (!target?.closest('[data-g24-mvd-disclosure]')) return;
    for (let node = target; node; node = node.parentElement) {
      if (node.tagName === 'DETAILS') node.open = true;
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (link) openPresentationAnchor(link.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => openPresentationAnchor(location.hash));
  openPresentationAnchor(location.hash);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-mvp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-pest-gallery')) {
    customElements.define('g24-pest-gallery', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.dialog = this.querySelector('dialog');
          this.openers = [...this.querySelectorAll('.g24-mvp__pest-track [data-pest-src]')];
          if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.openers.length) return;
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.addEventListener('click', (event) => {
            const opener = event.target.closest('[data-pest-src]');
            if (opener && this.openers.includes(opener)) {
              this.opener = opener;
              this.index = this.openers.indexOf(opener);
              if (!this.showImage()) return;
              if (!this.dialog.open) {
                this.previousOverflow = document.body.style.overflow;
                this.dialog.showModal();
                document.body.style.overflow = 'hidden';
                this.dialog.querySelector('[data-pest-close]').focus();
              }
            } else if (event.target.closest('[data-pest-close]')) {
              this.dialog.close();
            } else if (event.target.closest('[data-pest-prev]')) {
              this.step(-1);
            } else if (event.target.closest('[data-pest-next]')) {
              this.step(1);
            }
          }, options);
          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
              event.preventDefault();
              this.dialog.close();
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              this.step(event.key === 'ArrowLeft' ? -1 : 1);
            } else if (event.key === 'Tab') {
              const controls = [...this.dialog.querySelectorAll('button')].filter(button => !button.closest('[hidden]'));
              const first = controls[0], last = controls[controls.length - 1];
              if (!controls.includes(document.activeElement)) {
                event.preventDefault();
                first?.focus();
              } else if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
              } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
              }
            }
          }, options);
          const fullImage = this.dialog.querySelector('.g24-mvp__pest-full');
          fullImage.addEventListener('touchstart', (event) => {
            const touch = event.touches[0];
            this.touchStart = touch && event.touches.length === 1 ? { x: touch.clientX, y: touch.clientY } : null;
          }, { ...options, passive: true });
          fullImage.addEventListener('touchend', (event) => {
            const touch = event.changedTouches[0], start = this.touchStart;
            this.touchStart = null;
            if (!start || !touch || this.openers.length < 2) return;
            const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
            if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1);
          }, { ...options, passive: true });
          this.dialog.addEventListener('close', () => this.restorePage(), options);
        });
      }
      showImage() {
        const opener = this.openers[this.index];
        if (!opener) return false;
        const url = new URL(opener.dataset.pestSrc, document.baseURI);
        if (url.protocol !== 'https:') return false;
        const card = opener.closest('figure');
        const image = this.dialog.querySelector('.g24-mvp__pest-full');
        image.src = url.href;
        image.alt = opener.querySelector('img').alt;
        this.dialog.querySelector('[data-pest-title]').textContent = card.querySelector('h3').textContent;
        this.dialog.querySelector('[data-pest-caption]').textContent = card.querySelector('figcaption p').textContent;
        const navigation = this.dialog.querySelector('[data-pest-navigation]');
        navigation.hidden = this.openers.length < 2;
        const counter = this.dialog.querySelector('[data-pest-counter]');
        counter.textContent = counter.dataset.pestImageLabel + ' ' + (this.index + 1) + ' ' + counter.dataset.pestOfLabel + ' ' + this.openers.length;
        this.dialog.scrollTop = 0;
        return true;
      }
      step(direction) {
        if (!this.dialog?.open || this.openers.length < 2) return;
        this.index = (this.index + direction + this.openers.length) % this.openers.length;
        this.showImage();
      }
      restorePage() {
        if (this.previousOverflow !== undefined) {
          document.body.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restorePage();
        this.controller?.abort();
        this.controller = null;
        this.touchStart = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-pairings-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-pairings')) {
    customElements.define('g24-pairings', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pairing-track]');
        this.controls = this.querySelector('[data-pairing-controls]');
        this.prev = this.querySelector('[data-pairing-prev]');
        this.next = this.querySelector('[data-pairing-next]');
        if (!this.track || !this.controls) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = maximum < 8;
          this.prev.disabled = this.track.scrollLeft <= 8;
          this.next.disabled = this.track.scrollLeft >= maximum - 8;
        };
        const move = direction => {
          const first = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = (first?.getBoundingClientRect().width || this.track.clientWidth) + gap;
          this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.prev.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        this.updateControls = update;
        update();
        if (this.dataset.autoUrl) this.loadAutomaticProducts();
      }
      async loadAutomaticProducts() {
        const maximum = Math.min(4, Math.max(1, Number(this.dataset.maxItems) || 4));
        const seen = new Set([this.dataset.currentProduct, ...Array.from(this.track.children, card => card.dataset.pairingProduct)]);
        let nextUrl = this.dataset.autoUrl;
        const visited = new Set();
        try {
          while (nextUrl && this.track.children.length < maximum) {
            const url = new URL(nextUrl, window.location.origin);
            if (url.origin !== window.location.origin || visited.has(url.href)) break;
            visited.add(url.href);
            const response = await fetch(url.href, { signal: this.abort.signal, credentials: "same-origin" });
            if (!response.ok) { this.dataset.autoState = "unavailable"; break; }
            const document = new DOMParser().parseFromString(await response.text(), "text/html");
            const results = document.querySelector("[data-pairing-results]");
            if (!results || results.dataset.plantTag !== this.dataset.plantTag) { this.dataset.autoState = "unavailable"; break; }
            for (const card of results.querySelectorAll("[data-pairing-product]")) {
              const id = card.dataset.pairingProduct;
              if (!id || seen.has(id) || this.track.children.length >= maximum) continue;
              seen.add(id);
              this.track.append(card);
            }
            this.hidden = this.track.children.length === 0;
            this.updateControls();
            nextUrl = results.querySelector("[data-pairing-next-page]")?.getAttribute("href");
          }
        } catch (error) {
          // Curated cards remain usable when automatic additions are unavailable.
          if (error.name !== "AbortError") this.dataset.autoState = "unavailable";
        }
        if (!this.abort.signal.aborted && this.dataset.autoState !== "unavailable") this.dataset.autoState = "loaded";
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-product-overview"] && !Shopify.designMode) return;
  try {
    (()=>{
    function reveal(hash,explicit=false){if(!hash)return;let target;try{target=document.getElementById(decodeURIComponent(hash.slice(1)));}catch{return;}if(!target)return;if(!explicit&&target.closest('[data-g24-manufacturer]'))return;let node=target;while(node){if(node.tagName==='DETAILS')node.open=true;node=node.parentElement;}requestAnimationFrame(()=>target.scrollIntoView({block:'start',behavior:'auto'}));}
    document.addEventListener('click',event=>{const link=event.target.closest('a[href^="#G24"]');if(link)reveal(link.getAttribute('href'),true);});
    window.addEventListener('hashchange',()=>reveal(location.hash,true));
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>reveal(location.hash));else reveal(location.hash);
  })();
  (()=>{const sync=()=>{
    document.querySelectorAll('.g24-product-jump[data-g24-product-id]').forEach(nav=>{
      const reference=document.getElementById('G24ReferenceInfo-'+nav.dataset.g24ProductId);
      const link=nav.querySelector('a[href="#G24ProductDetails"]');
      if(nav.dataset.g24ProductId==='15939432710528'&&reference&&link)link.setAttribute('href','#'+reference.id);
    });
    document.querySelectorAll('a[href^="#G24"]').forEach(a=>{const id=a.getAttribute('href').slice(1);a.hidden=!document.getElementById(id);});
    document.querySelectorAll('g24-knowledge-picker select option[value]:not([value=""])').forEach(o=>{o.hidden=![...o.closest('section').querySelectorAll('[data-g24-care-key]')].some(el=>el.dataset.g24CareKey===o.value);});
    document.querySelectorAll('.g24-reference-info').forEach(s=>{if(!s.querySelector('details'))s.hidden=true;});
    document.querySelectorAll('.g24-guidance').forEach(s=>{if(!s.querySelector('details,.g24-guidance__manufacturer'))s.hidden=true;});
  };if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();document.addEventListener('shopify:section:load',sync);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-review-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('green24-review-enhancements')) {
    customElements.define('green24-review-enhancements', class extends HTMLElement {
      connectedCallback() {
        this.labels = new Map([
          ['Sort reviews by', this.dataset.sort],
          ['Pagination Navigation', this.dataset.pagination],
          ['Go to previous page', this.dataset.previousPage],
          ['Go to next page', this.dataset.nextPage],
          ['Close review form', this.dataset.closeForm],
          ['Review form pages', this.dataset.formPages],
          ['Rating', this.dataset.chooseRating],
          ['Privacy and Terms', this.dataset.privacy],
          ['Review form navigation', this.dataset.formNavigation],
          ['Previous step', this.dataset.previousStep],
          ['Next step', this.dataset.nextStep]
        ]);
        this.importedReviewUuids = new Set((this.dataset.importedReviewUuids || '').split(',').map(value => value.trim().toLowerCase()).filter(Boolean));
        this.importedReviewIds = new Set((this.dataset.importedReviewIds || '').split(',').map(value => value.trim()).filter(Boolean));
        this.numberFormat = window.g24MoneyFormatter(this.dataset.locale || 'en');
        this.observer = new MutationObserver(() => this.scheduleUpdate());
        this.observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-label', 'review-uuid', 'data-review-id', 'data-verified-buyer', 'data-number-of-reviews', 'data-product-id', 'data-id', 'data-shop-reviews']
        });
        this.updateLabels();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.pendingFrame) cancelAnimationFrame(this.pendingFrame);
        this.pendingFrame = null;
      }

      scheduleUpdate() {
        if (this.pendingFrame) return;
        this.pendingFrame = requestAnimationFrame(() => {
          this.pendingFrame = null;
          if (this.isConnected) this.updateLabels();
        });
      }

      translatedLabel(original) {
        if (this.labels.has(original)) return this.labels.get(original);
        let match = original.match(/^Go to page (\d+)$/);
        if (match) return this.dataset.page.replace('__NUMBER__', match[1]);
        match = original.match(/^([0-5](?:[.,]\d+)?) out of ([1-5]) stars?$/);
        if (match) {
          const rating = this.numberFormat.format(Number(match[1].replace(',', '.')));
          return this.dataset.rating.replace('__RATING__', rating).replace('__MAXIMUM__', match[2]);
        }
        match = original.match(/^([1-5]) stars?$/);
        if (match) return match[1] === '1' ? this.dataset.oneStar : this.dataset.stars.replace('__NUMBER__', match[1]);
        return original;
      }

      productReviewCount(root) {
        if (root.dataset.shopReviews === 'true') return 0;
        const currentProductId = document.querySelector('product-info[data-product-id]')?.dataset.productId || this.dataset.productId;
        const rootProductId = root.dataset.productId || root.dataset.id;
        if (!rootProductId || rootProductId !== currentProductId) return 0;
        const parseCount = value => /^\d+$/.test(value || '') && Number.isSafeInteger(Number(value)) ? Number(value) : 0;
        const counter = root.querySelector('.jdgm-rev-widg[data-number-of-reviews], .jm-review-widget[data-number-of-reviews]');
        if (counter) return parseCount(counter.getAttribute('data-number-of-reviews'));
        const publishedReviews = root.querySelectorAll('.jm-review-item[review-uuid], .jdgm-rev[data-review-id]');
        if (publishedReviews.length) return publishedReviews.length;
        return rootProductId === this.dataset.productId ? parseCount(this.dataset.productReviewCount) : 0;
      }

      updateAuthenticity(root) {
        let notice = document.getElementById('Green24ReviewAuthenticity');
        if (this.productReviewCount(root) === 0) {
          if (notice) notice.hidden = true;
          return;
        }
        if (!notice) {
          notice = document.createElement('details');
          notice.id = 'Green24ReviewAuthenticity';
          notice.className = 'green24-review-authenticity';
          const heading = document.createElement('summary');
          heading.textContent = this.dataset.authenticityHeading;
          notice.append(heading);
          const paragraph = document.createElement('p');
          paragraph.textContent = this.dataset.authenticityImported;
          notice.append(paragraph);
        }
        notice.hidden = false;
        if (root.previousElementSibling !== notice) root.before(notice);
        root.querySelectorAll('.jm-review-item[review-uuid], .jdgm-rev[data-review-id]').forEach(review => {
          const uuid = (review.getAttribute('review-uuid') || '').toLowerCase();
          const legacyId = review.getAttribute('data-review-id') || '';
          const imported = this.importedReviewUuids.has(uuid) || this.importedReviewIds.has(legacyId);
          let badge = review.querySelector('[data-green24-not-verified]');
          if (!imported || review.getAttribute('data-verified-buyer') === 'true') {
            badge?.remove();
            return;
          }
          const target = review.querySelector('.jm-reviewer-info__details, .jdgm-rev__header');
          if (!target) return;
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'green24-review-not-verified';
            badge.dataset.green24NotVerified = '';
            badge.textContent = this.dataset.notVerified;
          }
          if (badge.parentElement !== target) target.append(badge);
        });
      }

      updateLabels() {
        if (!document.querySelector('#judgeme_product_reviews')) {
          const notice = document.getElementById('Green24ReviewAuthenticity');
          if (notice) notice.hidden = true;
        }
        document.querySelectorAll('#judgeme_product_reviews, .jdgm-write-review-modal').forEach(root => {
          if (root.id === 'judgeme_product_reviews') this.updateAuthenticity(root);
          [root, ...root.querySelectorAll('[aria-label]')].forEach(element => {
            const original = element.getAttribute('aria-label');
            if (!original) return;
            const translated = this.translatedLabel(original);
            if (translated && translated !== original) element.setAttribute('aria-label', translated);
          });
          root.querySelectorAll('select.jdgm-sort-dropdown, select.jm-sort-filter__select').forEach(select => {
            const label = select.getAttribute('aria-label');
            const hasEnglishLabel = [...(select.labels || [])].some(element => element.textContent.trim() === 'Sort reviews by');
            if (!label && !select.getAttribute('aria-labelledby') && hasEnglishLabel && this.dataset.sort) {
              select.setAttribute('aria-label', this.dataset.sort);
              return;
            }
            if (label || select.getAttribute('aria-labelledby') || select.labels?.length) return;
            if (this.dataset.sort) select.setAttribute('aria-label', this.dataset.sort);
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-schnellkauf"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.G24SK) return;
    window.G24SK = true;
    var en = /^en/i.test(document.documentElement.lang || '');
    var T = en ? { adding: 'Adding …', added: 'In the cart', error: 'That did not work. Please try again.', close: 'Close', load: 'Loading …', choose: 'Please choose an option.' }
      : { adding: 'Wird hinzugefügt …', added: 'Im Warenkorb', error: 'Das hat nicht geklappt. Bitte erneut versuchen.', close: 'Schließen', load: 'Wird geladen …', choose: 'Bitte eine Ausführung wählen.' };
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var live = null, dlg = null, lastBtn = null;
    function say(t) {
      if (!live) {
        live = document.createElement('p');
        live.className = 'visually-hidden';
        live.setAttribute('role', 'status');
        document.body.appendChild(live);
      }
      live.textContent = '';
      setTimeout(function () { live.textContent = t; }, 50);
    }
    function cartEl() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
    function bubble() {
      fetch(root + '?section_id=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
        var s = new DOMParser().parseFromString(h, 'text/html').querySelector('.shopify-section'), b = document.getElementById('cart-icon-bubble');
        if (s && b) b.innerHTML = s.innerHTML;
      }).catch(function () {});
    }
    // wie die Artikelseite (product-form.js): /cart/add mit den Abschnitten der Warenkorb-Schublade
    function add(id, title) {
      var cart = cartEl(), fd = new FormData(), url = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
      fd.append('id', id);
      fd.append('quantity', '1');
      try {
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
      } catch (e) {}
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || T.error); return j; }); })
        .then(function (j) {
          var done = false;
          if (cart && typeof cart.renderContents === 'function' && j.sections) {
            try { if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.renderContents(j); done = true; } catch (e) {}
          }
          if (!done) bubble();
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'g24-schnellkauf', productVariantId: id, cartData: j }); } catch (e) {}
          say(T.added + (title ? ': ' + title : ''));
          return j;
        });
    }
    function dialog() {
      if (dlg) return dlg;
      dlg = document.createElement('dialog');
      dlg.className = 'g24-sk-dlg';
      dlg.setAttribute('aria-labelledby', 'g24-sk-titel');
      dlg.innerHTML = '<div class="g24-sk-dlg__in"><div class="g24-sk-dlg__kopf"><button type="button" class="g24-sk-dlg__zu" data-g24-sk-zu><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg></button></div><div data-g24-sk-inhalt></div><p class="g24-sk-dlg__msg" role="status"></p></div>';
      dlg.querySelector('[data-g24-sk-zu]').setAttribute('aria-label', T.close);
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-g24-sk-zu]')) { dlg.close(); return; }
        var go = e.target.closest('[data-g24-sk-go]');
        if (!go || go.disabled) return;
        var msg = dlg.querySelector('.g24-sk-dlg__msg'), sel = dlg.querySelector('input[name="g24-sk-v"]:checked'), t = dlg.querySelector('#g24-sk-titel');
        msg.classList.remove('is-fehler');
        if (!sel) { msg.textContent = T.choose; msg.classList.add('is-fehler'); return; }
        go.disabled = true;
        go.setAttribute('aria-busy', 'true');
        msg.textContent = T.adding;
        add(sel.value, t ? t.textContent.trim() : '').then(function () {
          msg.textContent = '';
          dlg.close();
        }, function (err) {
          msg.textContent = (err && err.message) || T.error;
          msg.classList.add('is-fehler');
        }).then(function () { go.disabled = false; go.removeAttribute('aria-busy'); });
      });
      dlg.addEventListener('close', function () {
        var b = lastBtn;
        lastBtn = null;
        if (b && !document.querySelector('cart-drawer.active, cart-drawer[open]')) { try { b.focus(); } catch (e) {} }
      });
      return dlg;
    }
    function choose(btn) {
      var d = dialog(), box = d.querySelector('[data-g24-sk-inhalt]'), msg = d.querySelector('.g24-sk-dlg__msg');
      var v = btn.getAttribute('data-g24-sk-v'), url = root + 'products/' + encodeURIComponent(btn.getAttribute('data-g24-sk-wahl')) + '?section_id=g24-schnellkauf' + (/^\d+$/.test(v || '') ? '&variant=' + v : '');
      lastBtn = btn;
      box.innerHTML = '<p class="g24-sk-dlg__laden">' + T.load + '</p>';
      msg.textContent = '';
      msg.classList.remove('is-fehler');
      if (!d.open) d.showModal();
      fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(); return r.text(); }).then(function (h) {
        var w = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-g24-sk-wahl-inhalt]');
        if (!w) throw new Error();
        box.innerHTML = '';
        box.appendChild(document.importNode(w, true));
        var f = box.querySelector('input[name="g24-sk-v"]:checked') || box.querySelector('[data-g24-sk-go], .g24-sk-wahl__mehr');
        if (f) f.focus();
      }).catch(function () {
        box.innerHTML = '';
        msg.textContent = T.error;
        msg.classList.add('is-fehler');
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-g24-sk]');
      if (!b || b.disabled) return;
      e.preventDefault();
      if (b.hasAttribute('data-g24-sk-wahl')) { choose(b); return; }
      var label = b.querySelector('.g24-sk__text'), old = label ? label.textContent : '', msg = b.parentNode.querySelector('.g24-sk__msg');
      if (msg) msg.textContent = '';
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
      if (label) label.textContent = T.adding;
      add(b.getAttribute('data-g24-sk'), b.getAttribute('data-title') || '').then(function () {
        if (label) label.textContent = T.added;
        b.classList.add('is-added');
        setTimeout(function () { if (label) label.textContent = old; b.classList.remove('is-added'); }, 2500);
      }, function (err) {
        if (label) label.textContent = old;
        if (msg) msg.textContent = (err && err.message) || T.error;
        say((err && err.message) || T.error);
      }).then(function () { b.disabled = false; b.removeAttribute('aria-busy'); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-search-bridge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('green24-search-bridge')) {
    customElements.define('green24-search-bridge', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.shoppingFirst = this.dataset.shoppingFirst === 'true';
        this.plants = new Set();
        this.products = new Set();
        this.status = this.querySelector('[data-g24-search-status]');
        this.retry = this.querySelector('[data-g24-search-retry]');
        this.retry.addEventListener('click', () => this.load());
        this.load();
        const native = document.getElementById('ProductGridContainer');
        if (native) {
          this.observer = new MutationObserver(() => this.updateNative());
          this.observer.observe(native, {childList: true, subtree: true});
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      searchURL(next) {
        const url = new URL(next || this.dataset.searchUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid search origin');
        url.searchParams.set('section_id', 'green24-search-plants');
        url.searchParams.set('q', this.dataset.query);
        if (!next) url.searchParams.set('page', '1');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url;
      }
      appendPage(page) {
        page.querySelectorAll('[data-g24-search-plant]').forEach(plant => {
          const id = plant.dataset.g24SearchPlant;
          if (this.plants.has(id)) return;
          this.plants.add(id);
          const productTemplate = plant.querySelector('[data-g24-plant-products]');
          productTemplate?.content.querySelectorAll('[data-g24-search-product]').forEach(product => {
            const productId = product.dataset.g24SearchProduct;
            if (this.products.has(productId)) return;
            this.products.add(productId);
            this.querySelector('[data-g24-promoted-list]').append(product.cloneNode(true));
          });
          const card = plant.cloneNode(true);
          card.querySelector('[data-g24-plant-products]')?.remove();
          this.querySelector('[data-g24-plant-list]').append(card);
        });
        this.querySelector('[data-g24-plant-group]').hidden = this.plants.size === 0;
        this.updateNative();
      }
      updateNative() {
        const params = new URL(location.href).searchParams;
        const hasFilters = Array.from(params.keys()).some(key => key.startsWith('filter.'));
        const sort = params.get('sort_by');
        const promote = !hasFilters && (!sort || sort === 'relevance');
        const nativeProducts = Array.from(document.querySelectorAll('[data-g24-native-product]'));
        const nativeIds = new Set(nativeProducts.map(card => card.dataset.g24NativeProduct));
        let additionalProducts = 0;
        this.querySelectorAll('[data-g24-promoted-list] [data-g24-search-product]').forEach(card => {
          card.hidden = this.shoppingFirst && nativeIds.has(card.dataset.g24SearchProduct);
          if (!card.hidden) additionalProducts += 1;
        });
        this.querySelector('[data-g24-promoted-group]').hidden = !promote || additionalProducts === 0;
        nativeProducts.forEach(card => {
          card.hidden = !this.shoppingFirst && promote && this.products.has(card.dataset.g24NativeProduct);
        });
        document.querySelectorAll('[data-g24-native-empty]').forEach(note => {
          note.hidden = this.plants.size > 0 || (promote && this.products.size > 0);
        });
        const results = Array.from(document.querySelectorAll('[data-g24-native-result]'));
        document.querySelectorAll('[data-g24-native-heading]').forEach(heading => {
          heading.hidden = results.length === 0 || results.every(card => card.hidden);
        });
        if (this.plants.size > 0) this.closest('.template-search')?.classList.remove('template-search--empty');
      }
      async load() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.retry.hidden = true;
        this.setAttribute('aria-busy', 'true');
        let next = null;
        const initial = this.querySelector('[data-g24-initial-plants]')?.content.querySelector('[data-g24-plant-search-page]');
        const visited = new Set();
        try {
          if (initial?.dataset.page === '1') {
            this.appendPage(initial);
            next = initial.dataset.nextUrl;
          } else {
            next = this.searchURL().href;
          }
          while (next) {
            const url = this.searchURL(next).href;
            if (visited.has(url)) throw new Error('Repeated plant page');
            visited.add(url);
            const response = await fetch(url, {signal: this.controller.signal, credentials: 'same-origin'});
            if (!response.ok) throw new Error('Plant search unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const page = html.querySelector('[data-g24-plant-search-page]');
            if (!page) throw new Error('Plant results unavailable');
            this.appendPage(page);
            next = page.dataset.nextUrl;
          }
          this.status.textContent = this.plants.size ? this.dataset.countText.replace('__count__', this.plants.size) : this.dataset.emptyText;
          this.status.hidden = this.shoppingFirst && this.plants.size === 0;
          this.hidden = this.shoppingFirst && this.plants.size === 0;
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.hidden = false;
            this.status.hidden = false;
            this.status.textContent = this.dataset.errorText;
            this.retry.hidden = false;
          }
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-shipping-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-shipping-dialog')) {
    customElements.define('g24-shipping-dialog', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-shipping-open]');
        if (!this.dialog?.showModal || !this.opener) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.opener.setAttribute('aria-haspopup', 'dialog');
        this.opener.setAttribute('aria-controls', this.dialog.id);
        this.opener.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
          event.preventDefault();
          this.dialog.showModal();
          document.documentElement.classList.add('g24-shipping-open');
        }, options);
        this.querySelector('[data-shipping-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('g24-shipping-open');
          if (this.opener.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.classList.remove('g24-shipping-open');
        }
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-sticky-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('g24-sticky-media')) {
    customElements.define('g24-sticky-media', class extends HTMLElement {
      connectedCallback() {
        this.product = this.closest('product-info');
        if (this.product?.dataset.g24StickyMedia !== 'true' || this.product.dataset.g24ReferenceLayout !== 'true') return;
        this.header = document.querySelector('.section-header');
        this.update = () => {
          const style = this.header && getComputedStyle(this.header);
          const headerHeight = style && ['sticky','fixed'].includes(style.position) ? this.header.getBoundingClientRect().height : 0;
          this.product.style.setProperty('--g24-sticky-top', `${Math.ceil(headerHeight + 16)}px`);
        };
        this.observer = new ResizeObserver(this.update);
        if (this.header) this.observer.observe(this.header);
        this.update();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-trustami-footer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.green24TrustamiOriginal) return;
    const state = { requested: false, loaded: false, privacyRequested: false, revoked: false, observer: null };
    const allowed = () => Boolean(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function' && window.Shopify.customerPrivacy.marketingAllowed());
    const clear = () => {
      document.querySelectorAll('.widget_container_overlay_sticker, #trustamiJsonLd, #trustamiFaqJsonLd, #trustami-mobile-view, #trustami-stars-badge-mobile-view, #trustami-shopauskunft-mobile-view').forEach(node => node.remove());
      document.querySelectorAll('.widget_container_comments_badge').forEach(node => { if (node.firstChild) node.innerHTML = ''; });
    };
    const ensureContainer = () => {
      if (document.querySelector('.widget_container_overlay_sticker')) return;
      const container = document.createElement('div');
      container.className = 'widget_container_overlay_sticker';
      document.body.appendChild(container);
    };
    const sync = () => {
      if (!allowed()) {
        if (state.requested) {
          state.revoked = true;
          clear();
          if (!state.observer && 'MutationObserver' in window) {
            state.observer = new MutationObserver(() => { if (!allowed()) clear(); });
            state.observer.observe(document.documentElement, { childList: true, subtree: true });
          }
        }
        return;
      }
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
      if (state.loaded && state.revoked && window.trustamiWidget && typeof window.trustamiWidget.sendJsonpRequest === 'function') {
        state.revoked = false;
        ensureContainer();
        window.trustamiWidget.sendJsonpRequest(window.trustamiWidget.getTrustamiURI(), () => { if (!allowed()) clear(); });
        return;
      }
      if (state.requested || document.getElementById('trustamiwidget')) return;
      state.requested = true;
      ensureContainer();
      const script = document.createElement('script');
      script.id = 'trustamiwidget';
      script.type = 'text/javascript';
      script.src = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
      script.setAttribute('data-profile', '5a04ac547e78cd6f5e8b4568');
      script.setAttribute('data-user', 'c88770dff8a9d8e7b97bf8c3835394649779b5be');
      script.setAttribute('data-platform', '0');
      if (document.querySelector('.widget_container_comments_badge')) {
        script.setAttribute('data-mode', '15,22');
        script.setAttribute('data-reviewlang', 'de');
      }
      script.async = true;
      script.onload = () => { state.loaded = true; if (!allowed()) sync(); };
      document.head.appendChild(script);
    };
    const initialize = () => {
      if (window.Shopify && window.Shopify.customerPrivacy) return sync();
      if (state.privacyRequested || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      state.privacyRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });
    };
    window.green24TrustamiOriginal = { initialize };
    document.addEventListener('visitorConsentCollected', sync);
    window.addEventListener('load', initialize, { once: true });
    initialize();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["green24-video-library"] && !Shopify.designMode) return;
  try {
    function green24InitFilmPosters(root) {
    root.querySelectorAll('.g24-film-library video').forEach(video=>{
      if(video.closest('g24-guide-video')||video.dataset.filmReady)return;
      video.dataset.filmReady='true';
      const button=document.createElement('button');button.type='button';button.className='g24-film-poster';
      button.setAttribute('aria-label',(video.getAttribute('aria-label')||'')+' – '+video.closest('.g24-film-library').dataset.filmWatch);
      if(video.poster){const image=document.createElement('img');image.src=video.poster;image.alt='';image.loading='lazy';button.append(image);}
      const label=document.createElement('span');label.textContent='▶ '+video.closest('.g24-film-library').dataset.filmWatch;button.append(label);
      video.before(button);video.hidden=true;
      button.addEventListener('click',()=>{button.hidden=true;video.hidden=false;video.focus({preventScroll:true});video.play().catch(()=>{});});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>green24InitFilmPosters(document),{once:true});else green24InitFilmPosters(document);
  document.addEventListener('shopify:section:load',event=>green24InitFilmPosters(event.target));
  document.addEventListener('toggle',event=>{
    const disclosure=event.target;
    if(disclosure.matches?.('.g24-film-library__accordion')&&!disclosure.open) disclosure.querySelectorAll('video').forEach(video=>video.pause());
  },true);
  } catch(e) { console.error(e); }
})();

})();
